function getNextMonthFirstDate(): {
	MM_DD_YYYY: string;
	YYYY_MM_DD: string;
} {
	const today = new Date();
	const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);

	const pad = (num: any) => String(num).padStart(2, "0");

	const mmddyyyy = `${pad(nextMonth.getMonth() + 1)}-${pad(nextMonth.getDate())}-${nextMonth.getFullYear()}`;
	const yyyymmdd = `${nextMonth.getFullYear()}-${pad(nextMonth.getMonth() + 1)}-${pad(nextMonth.getDate())}`;

	return {
		MM_DD_YYYY: mmddyyyy,
		YYYY_MM_DD: yyyymmdd
	};
}

export const VEBYearlyOpenAndCurrentEffectiveDate = {
	veb_current_effective_date_YYYYMMDD: getNextMonthFirstDate().YYYY_MM_DD,
	veb_yearly_open_effective_date_YYYYMMDD: getNextMonthFirstDate().MM_DD_YYYY,
	veb_current_effective_date_MMDDYYYY: getNextMonthFirstDate().MM_DD_YYYY,
	veb_yearly_open_effective_date_MMDDYYYY: getNextMonthFirstDate().MM_DD_YYYY
	// veb_yearly_open_effective_date_MMDDYYYY: getNextMonthFirstDate().MM_DD_YYYY
};
// export const VEBYearlyOpenAndCurrentEffectiveDate = {
// 	veb_current_effective_date_YYYYMMDD: getNextMonthFirstDate().YYYY_MM_DD,
// 	veb_yearly_open_effective_date_YYYYMMDD: "05-01-2026",
// 	veb_current_effective_date_MMDDYYYY: "05-01-2026",
// 	veb_yearly_open_effective_date_MMDDYYYY: "05-01-2026"
// 	// veb_yearly_open_effective_date_MMDDYYYY: getNextMonthFirstDate().MM_DD_YYYY
// };
